import { getLocation, postUploadBehavior } from '~/api/module/seo'
import { COOKIE_KEY, SESSION_QUERY_PASSTHROUGH } from '~/constants/config'

let country: string
export default defineNuxtRouteMiddleware((to, from) => {
  const historyStore = useRouteHistory()
  const { isMobile } = useDevice()

  if (import.meta.client) {
    // 只上报一次
    const {
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      from,
      ref,
      keyword_search,
      gclid,
    } = sessionGetItem(SESSION_QUERY_PASSTHROUGH) || {}
    const session_id = getCookie(COOKIE_KEY.USER_RANDOM_ID)
    function setBehavior() {
      postUploadBehavior({
        behavior: to.path,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
        session_id,
        country,
        keyword_search,
        gclid,
        source: from || ref,
        platform: isMobile ? 'mobile' : 'pc',
      })
    }

    if (country) {
      setBehavior()
    } else {
      const countryRes = getLocation()
      countryRes.then((res) => {
        country = res.country
        setBehavior()
      })
    }
  }

  /** 首次进入没有name */
  if (from.name) {
    historyStore.value.push({
      name: from.name,
      path: from.path,
      fullPath: from.fullPath,
      query: from.query as unknown as Record<string, string | null>,
      params: from.params as unknown as Record<string, string>,
    })
  }
})
